import React, { forwardRef, Fragment, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useHierarchicalMenu } from "react-instantsearch";
import { isValidArray } from "../../Layout/Common/common";
import { MAX_FACET_VALUES } from "../../Layout/Common/algoliaInstantLib";
import { Link, useLocation } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalContext";
import { useDevice } from "../../Context/hook/useDeviceType";
import { categoryByNameAndPath } from "../../utils/categoryIndex";
import { useCategoryLink } from "../../Context/hook/useCategoryLink";
import { set } from "lodash";
export const CustomHierarchicalMenu = forwardRef(({ onItemsChange }, ref) => {
  const { items, refine, createURL } = useHierarchicalMenu({
    attributes: ["categories.lvl0", "categories.lvl1", "categories.lvl2", "categories.lvl3", "categories.lvl4"],
    // Keep in step with MAX_FACET_VALUES: if this asks for more than <Configure> allows, the
    // category list silently shrinks the first time Configure re-applies its params.
    limit: MAX_FACET_VALUES,
  });
  const { categoryDataAll, categoryIndex } = useContext(GlobalContext);
  const [isOpen, setIsOpen] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const { device } = useDevice();
  const { pathname } = useLocation();
  const findActiveBranch = (list) => {
    try {
      if (!isValidArray(list)) return list;
      var refinedItem = list;
      for (let i = 0; i <= 5; i++) {
        var filters = refinedItem.find((item) => item.isRefined);
        if (filters) {
          if (isValidArray(filters.data)) refinedItem = filters.data;
          else {
            return null;
          }
        } else return refinedItem;
      }
    } catch (e) {
      console.error(e);
    }
  };
  const levelItems = findActiveBranch(items);

  const filteredItems =
    isValidArray(levelItems) && searchQuery.trim()
      ? levelItems.filter((item) => item.label?.toLowerCase().includes(searchQuery.trim().toLowerCase()))
      : levelItems;

  useEffect(() => {
    if (device == "mobile") {
      setIsOpen(null);
    } else setIsOpen(true);
  }, [device, pathname]);

  useEffect(() => {
    const collapseElement = document.getElementById("category-menu");
    if (!collapseElement) return;
    const handleShow = () => setIsOpen(true);
    const handleHide = () => setIsOpen(false);
    setIsOpen(true);
    collapseElement.addEventListener("show.bs.collapse", handleShow);
    collapseElement.addEventListener("hide.bs.collapse", handleHide);
    return () => {
      collapseElement.removeEventListener("show.bs.collapse", handleShow);
      collapseElement.removeEventListener("hide.bs.collapse", handleHide);
    };
  }, []);

  useImperativeHandle(ref, () => ({
    categoryRefine: refine,
  }));

  const latestItems = useRef(levelItems);
  latestItems.current = levelItems;
  // Identity-stable key: `levelItems` is a fresh array every render, so depending on it
  // directly would notify -> re-render -> notify forever.
  const itemsKey = isValidArray(levelItems)
    ? levelItems.map((item) => `${item.label}:${item.count}`).join("|")
    : String(levelItems);
  const onItemsChangeRef = useRef(onItemsChange);
  onItemsChangeRef.current = onItemsChange;
  useEffect(() => {
    if (onItemsChangeRef.current) onItemsChangeRef.current(latestItems.current);
  }, [itemsKey]);

  return (
    <Fragment>
      {levelItems != null && categoryDataAll && (
        <div className="accordion-item border-bottom mb-3" key={"category-menu"}>
          <h2 className="accordion-header">
            <button
              className={`accordion-button`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#category-menu"
              aria-expanded={true}
              aria-controls="category-menu"
            >
              Category
            </button>
          </h2>
          <div id="category-menu" className={`accordion-collapse collapse show`} data-bs-parent="category-filter">
            <div className="accordion-body">
              <div className="filter-selection-wrapper">
                <div className="category-menu-search mb-2">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search categories"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    aria-label="Search categories"
                  />
                </div>
                <div className="filterSelection-list">
                  <div className="filterSelection-listInner" style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {isValidArray(filteredItems) ? (
                      filteredItems.map((item) => {
                        var cat = categoryByNameAndPath(categoryIndex, item.label, item.value);
                        return <CategoryMenuLink key={item.value} item={item} category={cat} />;
                      })
                    ) : (
                      <div className="text-muted small">No categories found</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
});

const CategoryMenuLink = ({ item, category }) => {
  const getCategoryLink = useCategoryLink();
  const displayName = item.label;
  const targetUrl = getCategoryLink(category?.categoryId, category?.url);
  return (
    <div className="form-check custom-check m-0 p-0 pb-2" key={item.label}>
      <Link to={targetUrl} className="form-check-label form-check-color" style={{ color: "black" }}>
        {displayName}
        <span className="product-count">({item.count})</span>
      </Link>
    </div>
  );
};
